import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Category } from '../../../models/category/category.model';
import { CategoryService } from '../../../services/category/category.service';

@Component({
  selector: 'app-edit-subcategory',
  templateUrl: './edit-subcategory.component.html',
  styleUrls: ['./edit-subcategory.component.css']
})
/** edit-subcategory component*/
export class EditSubcategoryComponent {
  public subCategory = new Category();
  fileToUpload: File;
  fd = new FormData();
  selectedTinyImage: string;
  selectedSmallImage: string;
  selectedLargeImage: string;
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public dummyCategoryID: number;
  /** edit-subcategory ctor */
  constructor(private _avRoute: ActivatedRoute,
    private categoryService: CategoryService, private _router: Router) {
    if (this._avRoute.snapshot.params["id"]) {
      this.getCategoryById(this._avRoute.snapshot.params["id"]);
      this.GetCategoryList();

    }
  }

  getCategoryById(id: string) {
    this.categoryService.GetCategoryById(id).subscribe(
      data => {
        this.subCategory = data;
        this.GetCategoryByCategoryId(this.subCategory.parentCategoryID);
      }
    )
  }

  GetCategoryByCategoryId(categoryID: number) {
    this.categoryService.GetCategoryByCategoryId(categoryID).subscribe(
      data => {
        this.GetCategoryListByParent(data.parentCategoryID);
        this.dummyCategoryID = data.parentCategoryID;
      }
    )
  }
  GetCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data
      }
    )
  }
  GetCategoryListByParent(parentCategoryId: number) {
    this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
      data => {
        this.categoryList = data
      }
    )
  }


  uploadTinyImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("TinyImage", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedTinyImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadSmallImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("SmallImage", this.fileToUpload);
    //Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedSmallImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadLargeImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("LargeImage", this.fileToUpload);
    //Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedLargeImage = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onTextChange(Value: string) {
    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "");
    }
    this.subCategory.url = Value.toLowerCase();
  }

  onSubmit() {
    this.fd.append("Id", this.subCategory.id);
    this.fd.append("CategoryID", this.subCategory.categoryID.toString());
    this.fd.append("CategoryName", this.subCategory.categoryName);
    this.fd.append("IsActive", this.subCategory.isActive.toString());
    this.fd.append("Url", this.subCategory.url);
    this.fd.append("Detail", this.subCategory.detail);
    this.fd.append("TinyImage", this.subCategory.tinyImage);
    this.fd.append("SmallImage", this.subCategory.smallImage);
    this.fd.append("LargeImage", this.subCategory.largeImage);
    this.fd.append("CreatedDate", this.subCategory.createdDate.toString());
    this.fd.append("ParentCategoryID", this.subCategory.parentCategoryID.toString());
    this.fd.append("IsParent", "false");
    this.categoryService.AddSubCategory(this.fd);

  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/subcategory/edit-subcategory/edit-subcategory.component.ts